import { schema } from 'normalizr';

export const siteSchema = new schema.Entity(
  'sites',
  {},
  {
    idAttribute: site => site.id,
    processStrategy: site => {
      return {
        id: site.id,
        name: site.attributes.name,
        description: site.attributes.description,
        location: site.attributes.location,
        gps_latitude: site.attributes.gps_latitude,
        gps_longitude: site.attributes.gps_longitude,
        timezone: site.attributes.timezone,
        cost: site.attributes.cost,
        currency: site.attributes.currency,
        created_at: site.attributes.created_at,
      };
    },
  }
);

export const sampleSensor = new schema.Entity('sensorsFromSamples');
export const samplesSchema = new schema.Entity(
  'samples',
  { sensors: [sampleSensor] },
  {
    processStrategy: value => {
      const attributes = value.attributes;
      const getSensors = attribute => {
        if (attribute === undefined) {
          return [];
        }
        return attribute.map(a => {
          return a.sensor_id.toString();
        });
      };

      const attributeArrayToObject = attributes => {
        let object = {};

        if (attributes === undefined) {
          return object;
        }

        attributes.forEach(a => {
          object[a.sensor_id] = a.value;
        });

        return object;
      };

      return {
        id: value.id,
        timestamp: attributes.timestamp,
        temperature: attributes.system_temperature,
        sensors: ((
          apparent_power,
          complex_current,
          complex_voltage,
          current,
          energy,
          power,
          power_factor,
          reactive_power,
          signed_energy,
          signed_power
        ) => {
          return Array.from(
            new Set([
              ...getSensors(apparent_power),
              ...getSensors(complex_current),
              ...getSensors(complex_voltage),
              ...getSensors(current),
              ...getSensors(energy),
              ...getSensors(power),
              ...getSensors(power_factor),
              ...getSensors(reactive_power),
              ...getSensors(signed_energy),
              ...getSensors(signed_power),
            ])
          );
        })(
          attributes.apparent_power,
          attributes.complex_current,
          attributes.complex_voltage,
          attributes.current,
          attributes.energy,
          attributes.power,
          attributes.power_factor,
          attributes.reactive_power,
          attributes.signed_energy,
          attributes.signed_power
        ),

        apparent_power: attributeArrayToObject(attributes.apparent_power),
        complex_current: attributeArrayToObject(attributes.complex_current),
        complex_voltage: attributeArrayToObject(attributes.complex_voltage),
        current: attributeArrayToObject(attributes.current),
        energy: attributeArrayToObject(attributes.energy),
        power: attributeArrayToObject(attributes.power),
        power_factor: attributeArrayToObject(attributes.power_factor),
        reactive_power: attributeArrayToObject(attributes.reactive_power),
        signed_energy: attributeArrayToObject(attributes.signed_energy),
        signed_power: attributeArrayToObject(attributes.signed_power),
        dataLogger: value.id.split('_')[0],
      };
    },
  }
);

const strategy = {
  processStrategy: (value, parent) => {
    return {
      ...value,
      description: value.id,
      sensors: [parent.id],
      type: 'group',
    };
  },
  mergeStrategy: (a, b) => {
    return {
      ...a,
      ...b,
      sensors: [...(a.sensors || []), ...(b.sensors || [])],
    };
  },
};

const type = new schema.Entity('types', {}, strategy);
const area_functional = new schema.Entity('area_functional', {}, strategy);
const area_room = new schema.Entity('area_room', {}, strategy);
const equipment_type = new schema.Entity('equipment_type', {}, strategy);
const equipment_group = new schema.Entity('equipment_group', {}, strategy);
const building_floor = new schema.Entity('building_floor', {}, strategy);
const area_description = new schema.Entity('area_description', {}, strategy);
// const id_area_room = new schema.Entity('id_area_room', {}, strategy);
// const id_area_functional = new schema.Entity('id_area_functional', {}, strategy);
// const id_equipment_type = new schema.Entity('id_equipment_type', {}, strategy);
// const id_equipment_group = new schema.Entity('id_equipment_group', {}, strategy);
// const id_building_floor = new schema.Entity('id_building_floor', {}, strategy);

const sensor = new schema.Entity(
  'sensors',
  {
    type,
    area_room,
    area_functional,
    equipment_type,
    equipment_group,
    building_floor,
    area_description,
    // id_area_room,
    // id_area_functional,
    // id_equipment_type,
    // id_equipment_group,
    // id_building_floor,
  },
  {
    idAttribute: 'sensor_id',
    processStrategy: (value, parent) => {
      /* if (value.equipment_group === "Other") {
      value.equipment_group = "Other Equipment Group"
    }

    if (value.equipment_type === "Other") {
      value.equipment_type = "Other Equipment Type"
    }

    if (value.functional_area === "Other") {
      value.functional_area = "Other Functional Area"
    }

    if (value.room === "Other") {
      value.room = "Other Room"
    } */

      if (value.type === 'main') {
        return {
          id: value.sensor_id,
          type: { id: value.type },
          description: value.description ? value.description : null,
          phase: value.phase,
          data_logger: parent.id,
          area_room: { id: (value.room = 'Main') },
          area_functional: { id: (value.functional_area = 'Main') },
          building_floor: { id: (value.building_floor = 'Main') },
          equipment_type: { id: (value.equipment_type = 'Main') },
          equipment_group: { id: (value.equipment_group = 'Main') },
          area_description: { id: (value.equipment_group = 'Main') },
        };
      }

      return {
        id: value.sensor_id,
        type: { id: value.type },
        description: value.description ? value.description : null,
        data_logger: parent.id,
        phase: value.phase,
        area_room: value.room
          ? { id: value.room }
          : { id: 'Unknown Functional-Area' },
        area_functional: value.functional_area
          ? { id: value.functional_area }
          : { id: 'Unknown Room' },
        equipment_type: value.equipment_type
          ? { id: value.equipment_type }
          : { id: 'Unknown Equipment-Type' },
        equipment_group: value.equipment_group
          ? { id: value.equipment_group }
          : { id: 'Unknown Equipment-Group' },
        building_floor: value.building_floor
          ? { id: value.building_floor }
          : { id: 'Unknown Building Floor' },
        area_description: value.area_description
          ? { id: value.area_description }
          : { id: 'Unknown Area Description' },

        // id_area_room: value.room ? {id: Base64EncodeUrl(value.room)} : null,
        // id_area_functional: value.functional_area ? {id: Base64EncodeUrl(value.functional_area)} : null,
        // id_equipment_type: value.equipment_type ? {id: Base64EncodeUrl(value.equipment_type)} : null,
        // id_equipment_group: value.equipment_group ? {id: Base64EncodeUrl(value.equipment_group)} : null,
        // id_building_floor: value.building_floor ? {id: Base64EncodeUrl(value.building_floor)} : null,
      };
    },
  }
);

export const dataLoggerSchema = new schema.Entity(
  'loggers',
  {
    sensors: [sensor],
    siteSchema,
  },
  {
    processStrategy: value => ({
      id: value.id,
      description: value.attributes.description,
      mac_address: value.attributes.mac_address,
      num_phases: value.attributes.num_phases,
      sample_frequency: value.attributes.sample_frequency,
      sensors: value.attributes.sensors,
      site: value.relationships.site.data.id,
    }),
  }
);



// WEBPACK FOOTER //
// ./src/normalize.js